"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadFile = exports.bookToFile = exports.bookToBlob = void 0;
const XLSX = __importStar(require("xlsx"));
const bookToBlob = (workbook) => {
    const wbout = XLSX.writeXLSX(workbook, {
        type: "array",
    });
    const blob = new Blob([wbout], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    return blob;
};
exports.bookToBlob = bookToBlob;
const bookToFile = (workbook, fileName) => {
    const wbout = XLSX.writeXLSX(workbook, {
        type: "array",
    });
    const file = new File([wbout], fileName, {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    return file;
};
exports.bookToFile = bookToFile;
const downloadFile = (blob, fileName) => {
    // Blobをダウンロードリンクに変換し、ユーザーに提供
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.href = url;
    a.download = fileName;
    a.click();
    // ダウンロード後、リンクを削除
    window.setTimeout(function () {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    }, 0);
};
exports.downloadFile = downloadFile;
